import type { SeatKind } from './types';

// Mint-StaffProfile: dữ liệu mẫu 5 hồ sơ của board (script `PP`). Không lương, không CCCD / số tài khoản (ô nhạy cảm che ••••).

export interface ProfilePerson {
  id: string;
  name: string;
  pos: string;
  dept: string;
  team: string;
  title: string;
  titleN: string;
  level: string;
  group: string;
  seats: ReadonlyArray<readonly [string, SeatKind]>;
  boss: string;
  backup: string;
  join: string;
  driver: boolean;
  /** tài liệu bắt buộc còn thiếu (cccd · hdld · cv · form · photo) */
  miss: readonly string[];
  /** ngày phép đã dùng (trên 12) */
  used: number;
  /** hợp đồng hiện hành: loại · thời hạn */
  contract: readonly [string, string, string];
}

export const PROFILE_PEOPLE: readonly ProfilePerson[] = [
  { id: 'PhuongHT', name: 'Hà Thanh Phương', pos: 'Booking Staff', dept: 'CSD · Dịch vụ khách hàng', team: 'CSD-T2 · Tổ Đặt chỗ', title: 'CSD-BKG', titleN: 'Nhân viên Đặt chỗ', level: 'L03 · Executive', group: 'Staff', seats: [['CSD-BKG', 'Primary']], boss: '[CSD-MGR] trống → [BOD-DIR] PHILIP', backup: 'TranTPB', join: '12/Oct/2021', driver: false, miss: ['form'], used: 2.5, contract: ['HN-HDLD-12M-2025-014', 'XĐTH 12 tháng · ký lần 2', '12/Jan/2026 → 11/Jan/2027'] },
  { id: 'HANHLTM', name: 'Lê Thị Mỹ Hạnh', pos: 'Cost Accountant', dept: 'ACC · Kế toán — Tài chính', team: 'ACC-T1 · Tổ Kế toán chi phí', title: 'ACC-CP', titleN: 'Kế toán chi phí', level: 'L05 · Senior', group: 'Manager', seats: [['ACC-CP', 'Primary'], ['HRD-MGR', 'Concurrent']], boss: '[ACC-CA] trống → [BOD-DIR] PHILIP', backup: 'NGOCANH', join: '11/Jun/2020', driver: false, miss: [], used: 3, contract: ['HN-HDLD-KXD-2023-003', 'Không xác định thời hạn', 'từ 01/Jul/2023'] },
  { id: 'THANHTTK', name: 'Trương Thị Kim Thành', pos: 'Nhân viên Điều độ', dept: 'TRD · Vận tải', team: '—', title: 'TRD-DSP', titleN: 'Nhân viên Điều độ', level: 'L03 · Executive', group: 'Staff', seats: [['TRD-DSP', 'Primary']], boss: '[TRD-MGR] PHONGNT', backup: 'PHONGNT', join: '18/Jul/2024', driver: false, miss: ['cv', 'photo'], used: 7, contract: ['HN-HDLD-12M-2025-022', 'XĐTH 12 tháng · ký lần 1', '18/Jul/2025 → 17/Jul/2026 · đã gia hạn'] },
  { id: 'KHAINH', name: 'KHAINH', pos: 'Tài xế', dept: 'TRD · Vận tải', team: '—', title: 'TRD-DRV', titleN: 'Tài xế', level: 'L02 · Fresher', group: 'Staff', seats: [['TRD-DRV', 'Primary']], boss: '[TRD-MGR] PHONGNT', backup: 'ThangNV', join: '05/Mar/2025', driver: true, miss: ['form'], used: 4, contract: ['HN-HDLD-12M-2025-031', 'XĐTH 12 tháng · ký lần 1', '05/Mar/2025 → 04/Mar/2026 → gia hạn 36 tháng'] },
  { id: 'DAVID', name: 'Nguyễn Trường Giang', pos: 'Sales Manager', dept: 'SALE · Kinh doanh', team: '—', title: 'SALE-MGR', titleN: 'Trưởng phòng Kinh doanh', level: 'L07 · Manager', group: 'Manager', seats: [['SALE-MGR', 'Primary'], ['BOD-DDIR', 'Acting']], boss: '[BOD-DIR] PHILIP', backup: 'TUANNT', join: '02/Mar/2019', driver: false, miss: [], used: 4.5, contract: ['HN-HDLD-KXD-2021-001', 'Không xác định thời hạn', 'từ 02/Mar/2021'] },
];

export const personById = (id: string | undefined): ProfilePerson => PROFILE_PEOPLE.find((p) => p.id === id) ?? PROFILE_PEOPLE[0]!;

const nf = (x: number) => String(Math.round(x * 10) / 10).replace('.', ',');
const tailName = (s: string) => s.replace(/^\[[^\]]*\]\s*/, '') || 'trống';
const seatHead = (s: string) => (s.match(/^\[[^\]]*\]/) ?? [s])[0];

export interface ProfileSec {
  key: 'id' | 'job' | 'contact' | 'bank' | 'drv' | 'acc';
  title: string;
  note: string;
  tone: 'mute' | 'pri';
  /** [nhãn, giá trị | null nếu nhạy cảm, mẫu che] */
  fields: ReadonlyArray<readonly [string, string | null, string]>;
  sens: boolean;
  tip: string;
}

export function profileSections(p: ProfilePerson): ProfileSec[] {
  const idx = PROFILE_PEOPLE.findIndex((x) => x.id === p.id);
  return [
    { key: 'id', title: 'Định danh', note: '', tone: 'mute', sens: true, tip: 'Định danh. Ô nhạy cảm che ••••; HR bấm Hiện 30 giây, mỗi lần xem ghi nhật ký.', fields: [['Họ tên', p.name, ''], ['Tên tiếng Anh', '—', ''], ['UserName', p.id, ''], ['IDSTAFF', `HN-00${12 + idx}`, ''], ['Ngày sinh', null, '··/··/19··'], ['CCCD · số / ngày / nơi cấp', null, ''], ['MST cá nhân', null, ''], ['Người phụ thuộc', null, ''], ['Học vấn', null, '']] },
    { key: 'job', title: 'Công việc', note: 'HR sửa', tone: 'mute', sens: false, tip: 'HR sửa. Phòng, chức danh, cấp bậc khoá: đổi qua Quyết định nhân sự.', fields: [['Phòng · tổ', p.dept, ''], ['Chức danh (ghế)', `${p.title} · ${p.titleN}`, ''], ['Cấp bậc', p.level, ''], ['Nhóm', p.group, ''], ['Chi nhánh', 'SGN', ''], ['Ngày vào', p.join, ''], ['Cấp trên (theo ghế)', p.boss.replace(/^\[([A-Z-]+)\] trống → \[[A-Z-]+\] /, '$1 trống → '), ''], ['Người thay', p.backup, ''], ['Hạn HĐ', 'xem Lương & hợp đồng', '']] },
    { key: 'contact', title: 'Liên hệ', note: 'chính chủ tự sửa', tone: 'pri', sens: true, tip: 'Chính chủ tự sửa mục này, HR nhận thông báo.', fields: [['Điện thoại', null, ''], ['Email cá nhân', null, ''], ['Thường trú', null, ''], ['Tạm trú', null, ''], ['Liên hệ khẩn cấp', null, ''], ['Email công ty', null, '']] },
    { key: 'bank', title: 'Ngân hàng & thuế', note: 'HR sửa', tone: 'mute', sens: true, tip: 'HR sửa. Số tài khoản che, chỉ HRD xem.', fields: [['Ngân hàng', null, ''], ['Số tài khoản', null, ''], ['Chủ tài khoản', null, '']] },
    { key: 'drv', title: 'Giấy phép lái xe', note: p.driver ? 'bắt buộc với tài xế' : 'không áp dụng', tone: 'mute', sens: p.driver, tip: 'Bắt buộc với tài xế (TRD-DRV).', fields: p.driver ? [['Hạng', null, ''], ['Số GPLX', null, ''], ['Hết hạn', null, '']] : [['Hạng', '—', ''], ['Số GPLX', '—', ''], ['Hết hạn', '—', '']] },
    { key: 'acc', title: 'Tài khoản & đăng nhập', note: 'đồng bộ M365', tone: 'mute', sens: false, tip: 'Đồng bộ Microsoft 365 và đăng nhập HANA Ezy.', fields: [['Microsoft 365', 'Đã có · Business Standard', ''], ['Đăng nhập HANA Ezy', 'Bật · MFA bật', ''], ['Ảnh đại diện', p.miss.includes('photo') ? 'Chưa có' : 'Đã đồng bộ M365', '']] },
  ];
}

export interface ProfileSum { k: string; v: string; warn: boolean; tip: string; tab: string }

export function profileSums(p: ProfilePerson): ProfileSum[] {
  const missN = p.miss.length;
  const left = 12 - p.used;
  return [
    { k: 'Tài liệu bắt buộc', v: `${5 - missN}/5`, warn: missN > 0, tip: `Thiếu ${missN} loại`, tab: 'Tài liệu' },
    { k: 'Phép còn', v: `${nf(left)} ngày`, warn: left < 3, tip: `AnnualLeaveDays 12 · đã dùng ${p.used}`, tab: 'Nghỉ phép' },
    { k: 'HĐ hiện hành', v: p.contract[1].split(' · ')[0] ?? '', warn: false, tip: `${p.contract[0]} · ${p.contract[2]}`, tab: 'Lương & hợp đồng' },
    { k: 'Ghế đang giữ', v: String(p.seats.length), warn: p.seats.length > 1, tip: p.seats.map((s) => `${s[0]} ${s[1]}`).join(' · '), tab: 'Mô tả công việc' },
  ];
}

export const profileAudit = [
  { k: 'Sửa mục Liên hệ khẩn cấp (trước → sau)', who: 'chính chủ', when: '18/Oct/2026 10:12', kind: 'Sửa' },
  { k: 'Tải lên HĐLĐ bản ký', who: 'HANHLTM', when: '14/Oct/2026 15:40', kind: 'Tài liệu' },
  { k: 'Xem dữ liệu nhạy cảm 30 giây', who: 'HANHLTM', when: '14/Oct/2026 15:31', kind: 'Xem' },
  { k: 'Đồng bộ ảnh đại diện M365', who: 'Hệ thống', when: '01/Oct/2026 02:00', kind: 'Hệ thống' },
  { k: 'Áp QĐ HR-THANGCAP-2025-009', who: 'Hệ thống', when: '01/Jan/2025 00:05', kind: 'Quyết định' },
] as const;

export function profileBossLine(p: ProfilePerson): { who: string; seat: string } {
  const last = p.boss.split(' → ').pop() ?? '';
  return { who: tailName(last), seat: seatHead(last) };
}

/** Người phụ trách: chính chủ · cấp trên theo ghế · người thay · HR phụ trách. */
export function profilePeople(p: ProfilePerson): Array<{ u: string; role: string; hei: boolean }> {
  const b = profileBossLine(p);
  return [
    { u: p.id, role: `${p.pos} · chính chủ`, hei: p.id !== 'DAVID' },
    { u: b.who, role: `Cấp trên theo ghế ${b.seat}`, hei: true },
    { u: p.backup, role: 'Người thay (backup)', hei: true },
    { u: 'HANHLTM', role: '[HRD-MGR · kiêm] HR phụ trách hồ sơ', hei: true },
  ];
}
